import EnvelopIcon from '../../assets/svg/envelope-stroke.svg';
import { LinkShareTypes } from './consts';
import FBIcon from '../../assets/icons/svg/colored-icons/ic-colored-messanger.svg';
import WhatsAppIcon from '../../assets/icons/svg/colored-icons/ic-colored-whatsapp.svg';
import MessageIcon from '../../assets/icons/svg/colored-icons/ic-colored-messages.svg';

export const getShareableLinks = () => {
  if (window.navigator.userAgent.includes('Macintosh')) {
    return [
      { iconAsset: EnvelopIcon, type: LinkShareTypes.Email, title: 'Email' },
      { iconAsset: FBIcon, type: LinkShareTypes.Facebook, title: 'Messenger' },
      { iconAsset: WhatsAppIcon, type: LinkShareTypes.WhatsApp, title: 'WhatsApp' },
      { iconAsset: MessageIcon, type: LinkShareTypes.IMessage, title: 'Messages' },
    ];
  }
  return [
    { iconAsset: EnvelopIcon, type: LinkShareTypes.Email, title: 'Email' },
    { iconAsset: FBIcon, type: LinkShareTypes.Facebook, title: 'Messenger' },
    { iconAsset: WhatsAppIcon, type: LinkShareTypes.WhatsApp, title: 'WhatsApp' },
  ];
};
